import { ActionTree } from "vuex";
import { InvitesState } from "./InvitesState";
import { repositories } from "@service/api/Repositories";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { MeetingRepository } from "@api/repositories/MeetingRepository";
import { EventBus } from "@common/EventBus";
import { RealtimeCallback, SignalRMethod } from "@api/repositories/reatime-repository/types";
import Debug from "debug";
import {RealtimeRepository} from "@api/repositories/reatime-repository/RealtimeRepository";
//import { RealtimeCallback } from "@api/repositories/interfaces/RealtimeMessageInterface";

const debug = Debug("invites");

export const actions: ActionTree<InvitesState, any> = {
    setRepository({ commit }, repositories) {
        commit('setRepositories', repositories);
    },
    setDataHelper({ commit }, dateHelper) {
        commit('setDataHelper', dateHelper);
    },
    launchFetchingCount({ state, dispatch, commit, rootState }, eventId: string) {

        commit('setEventId', eventId);
        dispatch('fetchNotAnsweredCount');

        if (!state.useRealtimeUpdates) {
            clearInterval(state.intervalId);
            state.intervalId = window.setInterval(() => {
                if (!rootState.session.sessionId) {
                    clearInterval(state.intervalId);
                    return;
                }
                if (!document.hidden) {
                    dispatch('fetchNotAnsweredCount')
                }
            }, 5000)
        }

        else {
            dispatch("attachToRealTimeUpdates");
        }
    },
    attachToRealTimeUpdates({state, dispatch, rootState, commit }) {

        const lang = rootState.session?.language || navigator.language.split('-')[0] || "en";

        const cbMeeting: RealtimeCallback = (data) => {
            dispatch("updateRealTimeMeeting", data)
        }

        const cbInvite: RealtimeCallback = (data) => {
            dispatch("updateRealTimeInvite", data)
        }

        commit("setMeetingCb", cbMeeting);
        commit("setInviteCb", cbInvite);

        try {
            const realtimeRepository = repositories.get<RealtimeRepository>(RepositoryFabric.REALTIME);

            realtimeRepository.attach({
                [`meetings.${lang}`]: {
                    [SignalRMethod.meetingsInvitesUpdated]: state.realTimeCbInvite as RealtimeCallback,
                    [SignalRMethod.meetingsUpdated]: state.realTimeCbMeeting as RealtimeCallback
                }
            });
        }
        catch (e) {
            dispatch('reportError', e, { root: true });
        }
    },
    detachFromRealTimeUpdates({ dispatch, state, rootState }) {
        try {
            const lang = rootState.session?.language || navigator.language.split('-')[0] || "en";
            const realtimeRepository = repositories.get<RealtimeRepository>(RepositoryFabric.REALTIME);

            realtimeRepository.detach({
                [`meetings.${lang}`]: {
                    [SignalRMethod.meetingsInvitesUpdated]: state.realTimeCbInvite as RealtimeCallback,
                    [SignalRMethod.meetingsUpdated]: state.realTimeCbMeeting as RealtimeCallback
                }
            });
        }
        catch(e) {
            dispatch('reportError', e, { root: true });
        }
    },
    async updateRealTimeMeeting({ dispatch }, data) {
        try {
            const updatedMeeting = JSON.parse(data);
            debug(`updated invites from hub: %O`, updatedMeeting);

            if (!document.hidden && updatedMeeting.data?.isDeleted) {
                dispatch('fetchNotAnsweredCount');
            }
        }
        catch (e) {
            dispatch('reportError', e, {root: true});
        }

    },
    async updateRealTimeInvite({ dispatch, state }, data) {
        try {
            const updatedMeeting = JSON.parse(data);
            debug(`updated invites from hub: %O`, updatedMeeting);

            if (!document.hidden && !updatedMeeting?.data?.isDeleted) {
                dispatch('fetchNotAnsweredCount');
            }
        }
        catch (e) {
            dispatch('reportError', e, { root: true });
        }
    },
    stopFetching({ state, dispatch }) {
        if (state.useRealtimeUpdates) {
            dispatch("detachFromRealTimeUpdates");
        }
        else {
            clearInterval(state.intervalId);
        }
    },
    async fetchNotAnsweredCount({ state, commit, dispatch }): Promise<number> {
        let count = 0;
        if (state.repositories) {
            try {
                count = await (state.repositories.get(RepositoryFabric.MEETING) as MeetingRepository).invitesCount(state.eventId);
            } catch (e) {
                dispatch('reportException', e, { root: true });
            }
            if (state.invitesNotAnsweredCount != null && state.invitesNotAnsweredCount !== count) {
                EventBus.$emit('newInvites', count - state.invitesNotAnsweredCount);
            }
            if (state.invitesNotAnsweredCount != count) {
                commit('setNotAnsweredCount', count);
            }
        }
        return count;
    },
    decInvitesCount({ commit, state }) {
        const newValue = state.invitesNotAnsweredCount ? state.invitesNotAnsweredCount - 1 : 0;
        commit('setNotAnsweredCount', newValue);
    },
    removeMeeting({ state }, meetingId: string) {
        state.dataHelper?.removeMeeting(meetingId);
    }
};
